module.exports = __webpack_public_path__ + "img/mastercard.325c15e8.svg";